import {TTypographyColor, Typography} from 'components/Typography';
import {ISchedule} from 'modules/wineshops-list/models';
import {FC} from 'react';

interface IProps {
    schedule?: Record<string, Omit<ISchedule, 'day'>>[];
    textColor?: TTypographyColor;
}

export const WorkShopSchedule: FC<IProps> = ({schedule, textColor = 'gray100'}) => {
    return (
        <>
            {schedule?.map((scheduleData) => {
                const days = Object.keys(scheduleData)[0];
                const {from, to} = scheduleData[days];

                let time = `${from}`;

                if (to) {
                    time = `${time} - ${to}`;
                }

                return (
                    <Typography
                        color={textColor}
                        element={'div'}
                        itemProp={'openingHours'}
                        key={days}
                        variant={'label-16-r'}
                    >
                        {`${days}: ${time}`}
                    </Typography>
                );
            })}
        </>
    );
};
